<template>
  <v-container fluid class="" style="margin-top: 60px">
    <birthdayMain></birthdayMain>
    <blogMain></blogMain>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import birthdayMain from "@/components/pages/main/cumpleaños/cumpleMain";
import blogMain from "@/components/pages/main/blog/blogMain";
import Push from 'push.js';

export default {
  title() {
    return this.$route.meta.title
  },
  components: {
    birthdayMain,
    blogMain,
  },
  data() {
    return {
      changePasswordDialog: false,
      changePasswordPersistant: false,
    };
  },
  mounted() {
    this.verifyPasswordChange();
    if (Push.Permission.has()) {
    } else {
      Push.Permission.request(
        () => {
        },
        () => {
        }
      );
    }
  },
  methods: {
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    formatoFecha(date) {
      var fecha = moment(date).format("DD/MM/YYYY");
      return fecha;
    },
    verifyPasswordChange() {
      let changeTime = window.sessionStorage.getItem("CambioContraseña");
      if (changeTime != null) {
        if (changeTime.toString() != "undefined") {
          this.changePasswordDialog = true;
          let passwordWarned = window.sessionStorage.getItem("passwordWarned");
          if (changeTime == 0 || changeTime == -1) {
            this.changePasswordPersistant = true;
            passwordWarned = null;
          }

          if (passwordWarned == null) {
            let title = this.changePasswordPersistant == true ? "Contraseña expirada" : "Contraseña próxima a expirar";

            if (changeTime == -1) {
              title = "Bienvenido";
            }

            let today = new Date();
            let expireDate = this.addDays(today, parseInt(changeTime));
            let finalDate = this.formatoFecha(expireDate);

            let text =
              this.changePasswordPersistant == true
                ? "Su contraseña ha expirado, debe renovarla para seguir utilizando el sistema"
                : "Su contraseña caducará el " +
                finalDate +
                ", le recomendamos renovarla antes de la fecha mencionada";

            if (changeTime == -1) {
              text = "Al ser la primera vez que ingresa deberá modificar su contraseña.";
            }

            this.$swal({
              position: "center",
              icon: "warning",
              title: title,
              text: text,
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCloseButton: !this.changePasswordPersistant,
              showConfirmButton: true,
              confirmButtonColor: "#536DFE",
              confirmButtonText: "Cambiar Contraseña",
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push({ name: `Perfil` });
              }
            });
            window.sessionStorage.setItem("passwordWarned", 1);
          }
        }
      }
    },
  },
};
</script>

<style scoped></style>
